module.exports = __webpack_public_path__ + "img/sLongX3_350x350.fb09b826.jpg";